import { inject, Injectable } from '@angular/core';
import { ConfigService } from '@clean-code/shared/util-config';
import { GraphqlService, toGraphQLStringLiteral } from '@clean-code/shared/util-graphql';
import { Observable } from 'rxjs';
import { CompanyDropDown } from './company';

@Injectable({ providedIn: 'root' })
export class CompanyDropDownService {
  private graphqlService = inject(GraphqlService);
  private configService = inject(ConfigService);
  private url = this.configService.settings['graphql'];

  public getAllCompanies$(searchTerm: string): Observable<CompanyDropDown[]> {
    const escapedSearchTerm = toGraphQLStringLiteral(searchTerm);
    const query = `
    {
      allCompaniesForDropDown( where: {
        name: { contains: ${escapedSearchTerm}}
        }) {
            id
            name
        }
    }
    `;

    return this.graphqlService.query<CompanyDropDown[]>(query, null, this.url);
  }
}
